import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=22287670&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=ts&"
export * from "./logout.vue?vue&type=script&lang=ts&"
import style0 from "./logout.vue?vue&type=style&index=0&id=22287670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22287670",
  null
  
)

export default component.exports